import { Avatar, Typography } from '@mui/material';
import { AuditLog } from '@oxappsec/ox-unified-audit-logger';
import { FC } from 'react';
import DateFormat from '../../../elements/Date/DateFormat';
import InfoItem from '../InfoItem';
import {
  getLogDisplayName,
  resolveLogNameIcon,
} from '../../utils/audit-log-utils';

const BaseCard: FC<React.PropsWithChildren<ScanCardProps>> = ({ auditLog }) => {
  return (
    <>
      <InfoItem
        name='Time'
        data={<DateFormat date={new Date(auditLog.date)} />}
      />
      <InfoItem
        name='User'
        data={
          <>
            <Avatar
              alt={auditLog.userEmail}
              src={auditLog.userEmail}
              sx={{ width: 18, height: 18 }}
            />
            <Typography variant='body2' color='text.primary'>
              {auditLog.userEmail}
            </Typography>
          </>
        }
      />
      <InfoItem
        name='Operation'
        data={
          <>
            {resolveLogNameIcon(auditLog.logName)}
            <Typography variant='body2' color='text.primary'>
              {getLogDisplayName(auditLog.logName)}
            </Typography>
          </>
        }
      />
    </>
  );
};

export interface ScanCardProps {
  auditLog: AuditLog;
}

export default BaseCard;
